<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title v-if="title">{{ title }}</title>
    <path
      fill="#191c1f"
      fill-rule="evenodd"
      d="M12,22.5c5.8,0,10.5-4.7,10.5-10.5S17.8,1.5,12,1.5,1.5,6.2,1.5,12s4.7,10.5,10.5,10.5ZM12,24c6.6,0,12-5.4,12-12S18.6,0,12,0,0,5.4,0,12s5.4,12,12,12Z"
    />
    <path fill="#191c1f" fill-rule="evenodd" d="M18.6,7.4l-7.5,10.7-5.6-5.6,1.1-1.1,4.4,4.4,6.5-9.3,1.2.9Z" />
  </svg>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },
});
</script>
